import {
  ICanvasElement,
  ICanvasElementDrawArgs
} from '@/models/marketingCenter/canvas';
import { drawRoundedImage, printAtWithBreakStrategy } from '@/utils/canvas';

class BrandCanvasElement implements ICanvasElement {
  constructor(
    private readonly options: {
      width: number;
      height: number;
      x: number;
      y: number;
      radius: number;
      borderWidth?: number;
      rotateAngleDeg?: number;
      showBusinessName?: boolean;
      businessNameContainerX?: number;
      businessNameContainerWidth?: number;
    }
  ) {}

  showOnPreview = true;

  draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    return new Promise<void>((resolve, reject) => {
      const {
        width,
        height,
        x,
        y,
        radius,
        borderWidth = 8,
        rotateAngleDeg,
        showBusinessName,
        businessNameContainerWidth,
        businessNameContainerX
      } = this.options;

      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onerror = reject;
      image.onload = () => drawImageActualSize();
      image.src = `${args.brand}?`;

      const drawImageActualSize = () => {
        const posX = x < 0 ? args.canvas.width - width + x : x;
        const posY = y < 0 ? args.canvas.height - height + y : y;

        if (rotateAngleDeg) {
          context.save();

          const cx = posX + 0.5 * width;
          const cy = posY + 0.5 * height;
          context.translate(cx, cy);
          context.rotate((Math.PI / 180) * rotateAngleDeg);
          context.translate(-cx, -cy);
        }

        drawRoundedImage(context, image, posX, posY, width, height, radius, {
          width: borderWidth,
          color: '#E4EBF2'
        });

        if (showBusinessName) {
          this.drawBusinessName(
            context,
            args.business.name,
            posX,
            posY + height,
            businessNameContainerWidth,
            businessNameContainerX
          );
        }

        if (rotateAngleDeg) {
          context.restore();
        }

        resolve();
      };
    });
  }

  drawBusinessName(
    context: CanvasRenderingContext2D,
    businessName: string,
    x: number,
    y: number,
    containerWidth?: number,
    containerX?: number
  ) {
    const marginTop = 8;
    const size = 9;
    const maxWidth = 80;

    context.textAlign = 'center';
    context.font = `bold ${size}px "Inter"`;
    context.fillStyle = '#FFF';

    const posX =
      containerWidth && containerX ? containerX + containerWidth / 2 : x;

    printAtWithBreakStrategy(
      (...props) => context.fillText(...props),
      context,
      businessName,
      posX,
      y + marginTop + size,
      size,
      maxWidth
    );
  }
}

export default BrandCanvasElement;
